import '../financials/financialsResponsive.css';
import React from 'react';

function ScheduledPaymentsView() {
  return (
    <div className="ia-financials bg-white rounded-lg shadow-md p-8 text-center">
      <h3 className="text-2xl font-bold mb-4">Scheduled Payments</h3>
      <p className="text-gray-600">Manage scheduled and recurring payments</p>
      <p className="text-gray-500 mt-4">Coming in Phase 3!</p>
    </div>
  );
}

export default ScheduledPaymentsView;
